import React from "react";
import FormViewPublic from "./FormViewPublic";

export default function PublicFormViewPage() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <main className="p-6 md:p-8">
        <FormViewPublic />
      </main>
    </div>
  );
}
